import React from 'react';
import {observer} from 'mobx-react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {withState} from 'shared/core';
import ExpensesPageState from 'main/containers/expenses/state/ExpensesPageState';
import MyExpensesContainer from 'main/containers/expenses/components/my_expenses/components/MyExpensesContainer';
import ExpenseRequestsContainer from 'main/containers/expenses/components/expense_requests/components/ExpenseRequestsContainer';
import ManageContainer from 'main/containers/expenses/components/manage/components/ManageContainer';

const ExpensesPage = observer(({uiState}) => {
  const {scope} = uiState;

  return (
    <Router basename='/expenses'>
      <Switch>
        <Route exact path='/' render={() => <MyExpensesContainer scope={scope}/>}/>
        {scope.expenseRequests && <Route path='/expense_requests' render={() => <ExpenseRequestsContainer scope={scope}/>}/>}
        {scope.manage && <Route path='/manage' render={() => <ManageContainer scope={scope}/>}/>}
      </Switch>
    </Router>
  );
});

export default withState(ExpensesPage, ExpensesPageState);
